import { taskWorkTypeOptions } from '../constants/options.js';
import { titleCase } from '../util';
import PMScheduleModel from './PMScheduleModel';
import AbstractTaskTemplateModel from './AbstractTaskTemplateModel';
import { TemplateType } from '../mixins/TemplateLibraryMixin.js';

export default class VerifiedTaskTemplateModel extends AbstractTaskTemplateModel {
  init(data) {
    super.init(data);
    this.type = data.type ? taskWorkTypeOptions.find(option => option.id === data.type) : null;
    this.schedule = data.schedule || '';
    this.template_in_library = 'template_in_library' in data ? data.template_in_library : false;
    this.template_library_id = data.template_library_id || 0;
    this.locked = 'locked' in data ? data.locked : false;
    this.archived = 'archived' in data ? data.archived : true;
  }

  static getScheduleDefaultData(schedule) {
    return {
      schedule_type: schedule,
      schedule_data: (schedule === 'monthly'
        ? [{ ...PMScheduleModel.monthlyDayOfWeekScheduleDefault }]
        : schedule === 'yearly'
          ? [{ ...PMScheduleModel.yearlyOnDayOfWeekScheduleDefault }]
          : []),
    };
  }

  get work_type() {
    return this.type;
  }

  get workTypeName() {
    return this.type?.display_label || '';
  }

  get isVerifiedOrUnmodifiedVerified() {
    return true;
  }

  get scheduleDisplay() {
    return titleCase(this.schedule);
  }

  get createdDisplayDate() {
    return this.created;
  }

  get creatorName() {
    return this.company ? this.company.name : '';
  }

  get updatedDisplayDate() {
    return this.updated;
  }

  get updaterName() {
    return this.company ? this.company.name : ''; // Not tracking updaters on verified templates yet
  }

  get adderName() {
    return null;
  }

  categoryMatchesOptions(categoryOptions) {
    return (categoryOptions || []).some(
      category => category.name.toLowerCase() === this.category?.name.toLowerCase(),
    );
  }

  get companyImageUrl() {
    return this.company?.thumbnail_url;
  }

  get companyName() {
    return this.company?.name;
  }

  get templateType() {
    return TemplateType.VERIFIED;
  }
}
